/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiResultOfCloneReport,
    ApiResultOfCloneReportFromJSON,
    ApiResultOfCloneReportToJSON,
    ApiResultOfJsonEmailMessage,
    ApiResultOfJsonEmailMessageFromJSON,
    ApiResultOfJsonEmailMessageToJSON,
    ApiResultOfJsonFile,
    ApiResultOfJsonFileFromJSON,
    ApiResultOfJsonFileToJSON,
    ApiResultOfJsonTemplate,
    ApiResultOfJsonTemplateFromJSON,
    ApiResultOfJsonTemplateToJSON,
    ApiResultOfListOfJsonTemplate,
    ApiResultOfListOfJsonTemplateFromJSON,
    ApiResultOfListOfJsonTemplateToJSON,
    JsonTemplate,
    JsonTemplateFromJSON,
    JsonTemplateToJSON,
} from '../models';

export interface CloneTemplatesUsingPOSTRequest {
    eventId: number;
    sourceEventId: number;
}

export interface PreviewTemplateUsingPOSTRequest {
    json: JsonTemplate;
}

export interface ReplaceTemplateFileUsingPOSTRequest {
    eventId: number;
    uploadedFileId: number;
    fileId?: number;
    headerType?: ReplaceTemplateFileUsingPOSTHeaderTypeEnum;
}

export interface GetTemplateListUsingGETRequest {
    eventId?: number;
    templateType?: string;
    templateCode?: string;
    search?: string;
    orderCol?: string;
    orderDir?: string;
    start?: number;
    rows?: number;
}

export interface GetTemplateUsingGETRequest {
    templateId: number;
}

export interface SaveTemplateUsingPOSTRequest {
    json: JsonTemplate;
    testOnly?: boolean;
}

/**
 *
 */
export class TemplateControllerApi extends runtime.BaseAPI {

    /**
     * getTemplateList
     */
    async getTemplateListUsingGETRaw(requestParameters: GetTemplateListUsingGETRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfListOfJsonTemplate>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        if (requestParameters.templateType !== undefined) {
            queryParameters['templateType'] = requestParameters.templateType;
        }

        if (requestParameters.templateCode !== undefined) {
            queryParameters['templateCode'] = requestParameters.templateCode;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.orderCol !== undefined) {
            queryParameters['orderCol'] = requestParameters.orderCol;
        }

        if (requestParameters.orderDir !== undefined) {
            queryParameters['orderDir'] = requestParameters.orderDir;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.rows !== undefined) {
            queryParameters['rows'] = requestParameters.rows;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/rest-service/template/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfListOfJsonTemplateFromJSON(jsonValue));
    }

    /**
     * getTemplateList
     */
    async getTemplateListUsingGET(requestParameters: GetTemplateListUsingGETRequest = {}, initOverrides?: RequestInit): Promise<ApiResultOfListOfJsonTemplate> {
        const response = await this.getTemplateListUsingGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * getTemplate
     */
    async getTemplateUsingGETRaw(requestParameters: GetTemplateUsingGETRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfJsonTemplate>> {
        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getTemplateUsingGET.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/rest-service/template/{templateId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfJsonTemplateFromJSON(jsonValue));
    }

    /**
     * getTemplate
     */
    async getTemplateUsingGET(requestParameters: GetTemplateUsingGETRequest, initOverrides?: RequestInit): Promise<ApiResultOfJsonTemplate> {
        const response = await this.getTemplateUsingGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * saveTemplate
     */
    async saveTemplateUsingPOSTRaw(requestParameters: SaveTemplateUsingPOSTRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfJsonTemplate>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling saveTemplateUsingPOST.');
        }

        const queryParameters: any = {};

        if (requestParameters.testOnly !== undefined) {
            queryParameters['testOnly'] = requestParameters.testOnly;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/rest-service/template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JsonTemplateToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfJsonTemplateFromJSON(jsonValue));
    }

    /**
     * saveTemplate
     */
    async saveTemplateUsingPOST(requestParameters: SaveTemplateUsingPOSTRequest, initOverrides?: RequestInit): Promise<ApiResultOfJsonTemplate> {
        const response = await this.saveTemplateUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * cloneTemplates
     */
    async cloneTemplatesUsingPOSTRaw(requestParameters: CloneTemplatesUsingPOSTRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfCloneReport>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling cloneTemplatesUsingPOST.');
        }
        if (requestParameters.sourceEventId === null || requestParameters.sourceEventId === undefined) {
            throw new runtime.RequiredError('sourceEventId','Required parameter requestParameters.sourceEventId was null or undefined when calling cloneTemplatesUsingPOST.');
        }

        const queryParameters: any = {};

        queryParameters['eventId'] = requestParameters.eventId;
        queryParameters['sourceEventId'] = requestParameters.sourceEventId;

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/rest-service/template/clone`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfCloneReportFromJSON(jsonValue));
    }

    /**
     * cloneTemplates
     */
    async cloneTemplatesUsingPOST(requestParameters: CloneTemplatesUsingPOSTRequest, initOverrides?: RequestInit): Promise<ApiResultOfCloneReport> {
        const response = await this.cloneTemplatesUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * previewTemplate
     */
    async previewTemplateUsingPOSTRaw(requestParameters: PreviewTemplateUsingPOSTRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfJsonEmailMessage>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling previewTemplateUsingPOST.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/rest-service/template/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JsonTemplateToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfJsonEmailMessageFromJSON(jsonValue));
    }

    /**
     * previewTemplate
     */
    async previewTemplateUsingPOST(requestParameters: PreviewTemplateUsingPOSTRequest, initOverrides?: RequestInit): Promise<ApiResultOfJsonEmailMessage> {
        const response = await this.previewTemplateUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * replaceTemplateFile
     */
    async replaceTemplateFileUsingPOSTRaw(requestParameters: ReplaceTemplateFileUsingPOSTRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfJsonFile>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling replaceTemplateFileUsingPOST.');
        }
        if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
            throw new runtime.RequiredError('uploadedFileId','Required parameter requestParameters.uploadedFileId was null or undefined when calling replaceTemplateFileUsingPOST.');
        }

        const queryParameters: any = {};

        queryParameters['eventId'] = requestParameters.eventId;
        queryParameters['uploadedFileId'] = requestParameters.uploadedFileId;

        if (requestParameters.fileId !== undefined) {
            queryParameters['fileId'] = requestParameters.fileId;
        }

        if (requestParameters.headerType !== undefined) {
            queryParameters['headerType'] = requestParameters.headerType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/rest-service/template/file`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfJsonFileFromJSON(jsonValue));
    }

    /**
     * replaceTemplateFile
     */
    async replaceTemplateFileUsingPOST(requestParameters: ReplaceTemplateFileUsingPOSTRequest, initOverrides?: RequestInit): Promise<ApiResultOfJsonFile> {
        const response = await this.replaceTemplateFileUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ReplaceTemplateFileUsingPOSTHeaderTypeEnum {
    Org = 'ORG',
    Guest = 'GUEST'
}
